// //Minal codewithout Hippa
// import React, { useState, useEffect } from "react";
// import { db } from "../../firebase-config";
// import { Link, useNavigate } from "react-router-dom";
// import { ref, onValue, remove } from "firebase/database";
// import "./ViewAll.css";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import ChatNot from "../../components/Chat/ChatNot";
// import "../../components/Chat/ChatNot.css";
// import CryptoJS from "crypto-js";

// const decryptDataField = (encryptedData) => {
//   const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
//   try {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
//     if (!decryptedData) {
//       throw new Error("Decryption failed");
//     }
//     return decryptedData;
//   } catch (error) {
//     return encryptedData;
//   }
// };

// function ViewAll() {
//   const [users, setUser] = useState({});
//   const [activeSection, setActiveSection] = useState(null);
//   const navigate = useNavigate();
//   const adminName1 = localStorage.getItem("adminName");

//   useEffect(() => {
//     const users = ref(db, `superadmin/admins/${adminName1}`);
//     onValue(users, (snapshot) => {
//       if (snapshot.exists()) {
//         const userData = snapshot.val();
//         const decryptedData = {
//           ...userData,
//           doctors: userData.doctors
//             ? Object.keys(userData.doctors).reduce((acc, key) => {
//                 acc[key] = {
//                   ...userData.doctors[key],
//                   ID: decryptDataField(userData.doctors[key].ID),
//                   Name: decryptDataField(userData.doctors[key].Name),
//                 };
//                 return acc;
//               }, {})
//             : {},
//           patients: userData.patients
//             ? Object.keys(userData.patients).reduce((acc, key) => {
//                 acc[key] = {
//                   ...userData.patients[key],
//                   ID: decryptDataField(userData.patients[key].ID),
//                   FullName: decryptDataField(userData.patients[key].FullName),
//                   Age: decryptDataField(userData.patients[key].Age),
//                   DoctorAssigned: userData.patients[key].DoctorAssigned
//                     ? userData.patients[key].DoctorAssigned.map(
//                         (doctor) => doctor.name
//                       )
//                     : [],
//                 };
//                 return acc;
//               }, {})
//             : {},
//           technicians: userData.technicians
//             ? Object.keys(userData.technicians).reduce((acc, key) => {
//                 acc[key] = {
//                   ...userData.technicians[key],
//                   Name: decryptDataField(userData.technicians[key].Name),
//                   Email: decryptDataField(userData.technicians[key].Email),
//                 };
//                 return acc;
//               }, {})
//             : {},
//         };
//         setUser(decryptedData);
//       } else {
//         setUser({});
//       }
//     });
//   }, [adminName1]);

//   const toggleSection = (section) => {
//     setActiveSection(activeSection === section ? null : section);
//   };

//   const onDeleteRecord = async (type, id) => {
//     try {
//       if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
//         const userDoc = ref(
//           db,
//           `superadmin/admins/${adminName1}/${type}/${id}`
//         );
//         await remove(userDoc);
//         toast.success(
//           `${
//             type.charAt(0).toUpperCase() + type.slice(1)
//           } deleted successfully`,
//           {
//             position: "top-center",
//           }
//         );
//         navigate("/Admin/ViewAll");
//       }
//     } catch (err) {
//       toast.error("Error deleting record");
//     }
//   };

//   const renderDoctorRows = (doctors) => {
//     return Object.keys(doctors).map((key) => (
//       <tr key={key}>
//         <td>{doctors[key].ID}</td> {/* ID column */}
//         <td>{doctors[key].Name}</td> {/* Name column */}
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePageDoc${key}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("doctors", key)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   const renderPatientRows = (patients) => {
//     return Object.keys(patients).map((key) => (
//       <tr key={key}>
//         <td>{patients[key].ID}</td> {/* ID column */}
//         <td>{patients[key].FullName}</td> {/* Name column */}
//         <td>{patients[key].Age}</td> {/* Age column */}
//         <td>
//           {patients[key].DoctorAssigned.length > 0
//             ? patients[key].DoctorAssigned.join(", ")
//             : "Not assigned"}
//         </td>{" "}
//         {/* Doctor Assigned column */}
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePagePatient${key}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("patients", key)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   const renderTechnicianRows = (technicians) => {
//     return Object.keys(technicians).map((key) => (
//       <tr key={key}>
//         <td>{technicians[key].Name}</td> {/* Name column */}
//         <td>{technicians[key].Email}</td> {/* Email column */}
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePageTech${key}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("technicians", key)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   return (
//     <>
//       <div className="main-content">
//         <div className="adminsidebar">{/* Sidebar content */}</div>

//         <div className="top-nav">
//           <h1
//             style={{
//               fontSize: "24px",
//               margin: 0,
//               textDecoration: "underline",
//               marginLeft: "40px",
//             }}
//           >
//             WELCOME
//           </h1>
//           <div style={{ marginTop: "100px" }}>
//             <Link to="/Admin" className="homeButton">
//               <i
//                 id="backIcon"
//                 className="fas fa-long-arrow-alt-left fa-lg fa-2x"
//               ></i>
//             </Link>
//           </div>
//         </div>

//         <div className="container div-viewAll">
//           <div className="card-header">
//             <strong>AdminName:</strong>
//             <span className="admin-name">{adminName1}</span>
//             <hr />

//             <div
//               className={`accordion-section doctors-section ${
//                 activeSection === "doctors" ? "expanded" : ""
//               }`}
//             >
//               <h3
//                 onClick={() => toggleSection("doctors")}
//                 className="accordion-title"
//               >
//                 DOCTORS
//                 <span
//                   className={`arrow ${
//                     activeSection === "doctors" ? "up" : "down"
//                   }`}
//                 ></span>
//               </h3>

//               {activeSection === "doctors" && (
//                 <>
//                   {users.doctors && Object.keys(users.doctors).length > 0 ? (
//                     <table className="styled-table">
//                       <thead>
//                         <tr>
//                           <th className="th-head">ID</th>
//                           <th className="th-head">Name</th>
//                           <th className="th-head T-ACTIONVIEWALL">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>{renderDoctorRows(users.doctors)}</tbody>
//                     </table>
//                   ) : (
//                     <p>No doctors available.</p>
//                   )}
//                 </>
//               )}
//             </div>

//             <div
//               className={`accordion-section patients-section ${
//                 activeSection === "patients" ? "expanded" : ""
//               }`}
//             >
//               <h3
//                 onClick={() => toggleSection("patients")}
//                 className="accordion-title"
//               >
//                 PATIENTS
//                 <span
//                   className={`arrow ${
//                     activeSection === "patients" ? "up" : "down"
//                   }`}
//                 ></span>
//               </h3>

//               {activeSection === "patients" && (
//                 <>
//                   {users.patients && Object.keys(users.patients).length > 0 ? (
//                     <table className="styled-table">
//                       <thead>
//                         <tr>
//                           <th className="th-head">ID</th>
//                           <th className="th-head">Name</th>
//                           <th className="th-head">Age</th>
//                           <th className="th-head">Doctor Assigned</th>
//                           <th className="th-head T-ACTIONVIEWALL">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>{renderPatientRows(users.patients)}</tbody>
//                     </table>
//                   ) : (
//                     <p>No patients available.</p>
//                   )}
//                 </>
//               )}
//             </div>

//             <div
//               className={`accordion-section technicians-section ${
//                 activeSection === "technicians" ? "expanded" : ""
//               }`}
//             >
//               <h3
//                 onClick={() => toggleSection("technicians")}
//                 className="accordion-title"
//               >
//                 TECHNICIANS
//                 <span
//                   className={`arrow ${
//                     activeSection === "technicians" ? "up" : "down"
//                   }`}
//                 ></span>
//               </h3>

//               {activeSection === "technicians" && (
//                 <>
//                   {users.technicians &&
//                   Object.keys(users.technicians).length > 0 ? (
//                     <table className="styled-table">
//                       <thead>
//                         <tr>
//                           <th className="th-head">Name</th>
//                           <th className="th-head">Email</th>
//                           <th className="th-head T-ACTIONVIEWALL">Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>{renderTechnicianRows(users.technicians)}</tbody>
//                     </table>
//                   ) : (
//                     <p>No technicians available.</p>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <ChatNot />
//       </div>
//       <ToastContainer />
//     </>
//   );
// }

// export default ViewAll;



// import React, { useState, useEffect } from "react";
// import { db } from "../../firebase-config";
// import { Link, useNavigate } from "react-router-dom";
// import { ref, onValue, remove } from "firebase/database";
// import "./ViewAll.css";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import CryptoJS from "crypto-js";

// const decryptDataField = (encryptedData) => {
//   const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
//   try {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
//     if (!decryptedData) {
//       throw new Error("Decryption failed");
//     }
//     return decryptedData;
//   } catch (error) {
//     return encryptedData; // Return as-is if decryption fails
//   }
// };

// function ViewAll() {
//   const [users, setUsers] = useState({});
//   const navigate = useNavigate();
//   const adminName1 = localStorage.getItem("adminName");

//   useEffect(() => {
//     const usersRef = ref(db, `superadmin/admins/${adminName1}`);
//     onValue(usersRef, (snapshot) => {
//       if (snapshot.exists()) {
//         const userData = snapshot.val();

//         const decryptedDoctors = userData.doctors
//           ? Object.keys(userData.doctors).map((key) => {
//               const doctor = userData.doctors[key];
//               return {
//                 ID: decryptDataField(doctor.ID),
//                 Name: decryptDataField(doctor.Name),
//                 Email: decryptDataField(doctor.Email),
//               };
//             })
//           : [];

//         const decryptedPatients = userData.patients
//           ? Object.keys(userData.patients).map((key) => {
//               const patient = userData.patients[key];
//               return {
//                 ID: decryptDataField(patient.ID),
//                 FullName: decryptDataField(patient.FullName),
//                 Age: decryptDataField(patient.Age),
//                 Gender: decryptDataField(patient.Gender),
//                 AddedBy: patient.Addedby,
//                 ClinicalText: patient.Clinical_Textarea,
//                 ClinicalTimestamp: patient.Clinical_Timestamp,
//                 StudyDate: patient.StudyDate,
//                 Version: patient.Version,
//                 DoctorAssigned: patient.DoctorAssigned_Final || [],
//                 uploads: {
//                   Dicom3D: decryptDataField(patient.uploads?.Dicom_3DURL || ""),
//                   Report: decryptDataField(patient.uploads?.Dicom_ReportURL || ""),
//                 },
//               };
//             })
//           : [];

//         const decryptedTechnicians = userData.technicians
//           ? Object.keys(userData.technicians).map((key) => {
//               const technician = userData.technicians[key];
//               return {
//                 ID: decryptDataField(technician.ID),
//                 Name: decryptDataField(technician.Name),
//                 Email: decryptDataField(technician.Email),
//               };
//             })
//           : [];

//         setUsers({
//           ...userData,
//           doctors: decryptedDoctors,
//           patients: decryptedPatients,
//           technicians: decryptedTechnicians,
//         });
//       } else {
//         setUsers({});
//       }
//     });
//   }, [adminName1]);

//   const onDeleteRecord = async (type, id) => {
//     try {
//       if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
//         const userDoc = ref(db, `superadmin/admins/${adminName1}/${type}/${id}`);
//         await remove(userDoc);
//         toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} deleted successfully`, {
//           position: "top-center",
//         });
//         navigate("/Admin/ViewAll");
//       }
//     } catch (err) {
//       toast.error("Error deleting record");
//     }
//   };

//   const renderDoctorRows = (doctors) => {
//     return doctors.map((doctor, index) => (
//       <tr key={index}>
//         <td>{doctor.ID}</td>
//         <td>{doctor.Name}</td>
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePageDoctor/${index}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("doctors", index)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   const renderPatientRows = (patients) => {
//     return patients.map((patient, index) => (
//       <tr key={index}>
//         <td>{patient.ID}</td>
//         <td>{patient.FullName}</td>
//         <td>{patient.Age}</td>
//         <td>{patient.Gender}</td>
//         <td>
//           {patient.DoctorAssigned.length > 0
//             ? patient.DoctorAssigned.join(", ")
//             : "Not assigned"}
//         </td>
//         <td>{patient.StudyDate}</td>
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePagePatient/${index}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("patients", index)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   const renderTechnicianRows = (technicians) => {
//     return technicians.map((technician, index) => (
//       <tr key={index}>
//         <td>{technician.ID}</td>
//         <td>{technician.Name}</td>
//         <td>{technician.Email}</td>
//         <td>
//           <div className="action-buttons">
//             <Link to={`/Admin/UpdatePageTechnician/${index}`}>
//               <button className="btn btn-edit">Update</button>
//             </Link>
//             <button
//               className="btn btn-delete"
//               onClick={() => onDeleteRecord("technicians", index)}
//             >
//               Delete
//             </button>
//           </div>
//         </td>
//       </tr>
//     ));
//   };

//   return (
//     <>
//       <div className="main-content">
//         <div className="adminsidebar">{/* Sidebar content */}</div>
//         <div className="container div-viewAll">
//           {/* Doctors Section */}
//           <div className="section">
//             <h2>Doctors</h2>
//             {users.doctors && users.doctors.length > 0 ? (
//               <table className="styled-table">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Name</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>{renderDoctorRows(users.doctors)}</tbody>
//               </table>
//             ) : (
//               <p>No doctors available</p>
//             )}
//           </div>

//           {/* Patients Section */}
//           <div className="section">
//             <h2>Patients</h2>
//             {users.patients && users.patients.length > 0 ? (
//               <table className="styled-table">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Name</th>
//                     <th>Age</th>
//                     <th>Gender</th>
//                     <th>Doctor Assigned</th>
//                     <th>Study Date</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>{renderPatientRows(users.patients)}</tbody>
//               </table>
//             ) : (
//               <p>No patients available</p>
//             )}
//           </div>

//           {/* Technicians Section */}
//           <div className="section">
//             <h2>Technicians</h2>
//             {users.technicians && users.technicians.length > 0 ? (
//               <table className="styled-table">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Name</th>
//                     <th>Email</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>{renderTechnicianRows(users.technicians)}</tbody>
//               </table>
//             ) : (
//               <p>No technicians available</p>
//             )}
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </>
//   );
// }

// export default ViewAll;

// jan 9 2025

import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { Link, useNavigate } from "react-router-dom";
import { ref, onValue, remove } from "firebase/database";
import "./ViewAll.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";
import CryptoJS from "crypto-js";

const decryptDataField = (encryptedData) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedData) {
      throw new Error("Decryption failed");
    }
    return decryptedData;
  } catch (error) {
    return encryptedData;
  }
};

function ViewAll() {
  const [users, setUser] = useState({});
  const [activeSection, setActiveSection] = useState(null);
  const navigate = useNavigate();
  const adminName1 = localStorage.getItem("adminName");

  // useEffect(() => {
  //   const users = ref(db, `superadmin/admins/${adminName1}`);
  //   onValue(users, (snapshot) => {
  //     if (snapshot.exists()) {
  //       const userData = snapshot.val();
  //       const decryptedData = {
  //         ...userData,
  //         doctors: userData.doctors
  //           ? Object.keys(userData.doctors).reduce((acc, key) => {
  //               acc[key] = {
  //                 ...userData.doctors[key],
  //                 ID: decryptDataField(userData.doctors[key].ID),
  //                 Name: decryptDataField(userData.doctors[key].Name),
  //               };
  //               return acc;
  //             }, {})
  //           : {},
  //         patients: userData.patients
  //           ? Object.keys(userData.patients).reduce((acc, key) => {
  //               const patient = userData.patients[key];
  //               const decryptedPatient = {
  //                 ...patient,
  //                 ID: decryptDataField(patient.ID),
  //                 FullName: decryptDataField(patient.FullName),
  //                 Age: decryptDataField(patient.Age),
  //                 DoctorAssigned: Array.isArray(patient.DoctorAssigned)
  //                   ? patient.DoctorAssigned.map((doctor) => doctor.name)
  //                   : patient.DoctorAssigned
  //                   ? [decryptDataField(patient.DoctorAssigned)]
  //                   : [], // Handle both string and array formats
  //                 Gender: decryptDataField(patient.Gender),
  //               };
  //               acc[key] = decryptedPatient;
  //               return acc;
  //             }, {})
  //           : {},
  //         technicians: userData.technicians
  //           ? Object.keys(userData.technicians).reduce((acc, key) => {
  //               acc[key] = {
  //                 ...userData.technicians[key],
  //                 Name: decryptDataField(userData.technicians[key].Name),
  //                 Email: decryptDataField(userData.technicians[key].Email),
  //               };
  //               return acc;
  //             }, {})
  //           : {},
  //       };
  //       setUser(decryptedData);
  //     } else {
  //       setUser({});
  //     }
  //   });
  // }, [adminName1]);

  
  
  useEffect(() => {
    const users = ref(db, `superadmin/admins/${adminName1}`);
    onValue(users, (snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const decryptedData = {
          ...userData,
          doctors: userData.doctors
            ? Object.keys(userData.doctors).reduce((acc, key) => {
                acc[key] = {
                  ...userData.doctors[key],
                  ID: decryptDataField(userData.doctors[key].ID),
                  Name: decryptDataField(userData.doctors[key].Name),
                };
                return acc;
              }, {})
            : {},
          patients: userData.patients
            ? Object.keys(userData.patients).reduce((acc, key) => {
                const patient = userData.patients[key];
                const decryptedPatient = {
                  ...patient,
                  ID: decryptDataField(patient.ID),
                  FullName: decryptDataField(patient.FullName),
                  Age: decryptDataField(patient.Age),
                  Version: patient.Version || "01", // Default to Version 01 if not specified
                  DoctorAssigned: (patient.Version === "03") // Check if version is "03"
                    ? (Array.isArray(patient.DoctorAssigned) 
                      ? patient.DoctorAssigned.map((doctor) => {
                          // Decrypt doctor name from object
                          if (typeof doctor === "object" && doctor.name) {
                            return decryptDataField(doctor.name); // Decrypt the doctor's name if it's an object
                          } else if (typeof doctor === "string") {
                            return decryptDataField(doctor); // If it's a string, just decrypt it
                          }
                          return "Unknown"; // If the structure doesn't match, return "Unknown"
                        })
                      : [])
                    : (Array.isArray(patient.DoctorAssigned) // For versions other than "03"
                      ? patient.DoctorAssigned.map((doctor) => decryptDataField(doctor)) 
                      : patient.DoctorAssigned
                      ? [decryptDataField(patient.DoctorAssigned)]
                      : []), // For versions without DoctorAssigned
                  Gender: decryptDataField(patient.Gender),
                };
                acc[key] = decryptedPatient;
                return acc;
              }, {})
            : {},
          technicians: userData.technicians
            ? Object.keys(userData.technicians).reduce((acc, key) => {
                acc[key] = {
                  ...userData.technicians[key],
                  Name: decryptDataField(userData.technicians[key].Name),
                  Email: decryptDataField(userData.technicians[key].Email),
                };
                return acc;
              }, {})
            : {},
        };
        setUser(decryptedData);
      } else {
        setUser({});
      }
    });
  }, [adminName1]);
  
  
  
  
  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  const onDeleteRecord = async (type, id) => {
    try {
      if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
        const userDoc = ref(
          db,
          `superadmin/admins/${adminName1}/${type}/${id}`
        );
        await remove(userDoc);
        toast.success(
          `${
            type.charAt(0).toUpperCase() + type.slice(1)
          } deleted successfully`,
          {
            position: "top-center",
          }
        );
        navigate("/Admin/ViewAll");
      }
    } catch (err) {
      toast.error("Error deleting record");
    }
  };

  const renderDoctorRows = (doctors) => {
    return Object.keys(doctors).map((key) => (
      <tr key={key}>
        <td>{doctors[key].ID}</td> {/* ID column */}
        <td>{doctors[key].Name}</td> {/* Name column */}
        <td>
          <div className="action-buttons">
            <Link to={`/Admin/UpdatePageDoc${key}`}>
              <button className="btn btn-edit">Update</button>
            </Link>
            <button
              className="btn btn-delete"
              onClick={() => onDeleteRecord("doctors", key)}
            >
              Delete
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  // const renderPatientRows = (patients) => {
  //   return Object.keys(patients).map((key) => {
  //     const patient = patients[key];
  //     return (
  //       <tr key={key}>
  //         <td>{patient.ID}</td> {/* ID column */}
  //         <td>{patient.FullName}</td> {/* Name column */}
  //         <td>{patient.Age}</td> {/* Age column */}
  //         <td>
  //           {patient.DoctorAssigned.length > 0
  //             ? patient.DoctorAssigned.join(", ")
  //             : "Not assigned"}
  //         </td>{" "}
  //         {/* Doctor Assigned column */}
  //         <td>
  //           <div className="action-buttons">
  //             <Link to={`/Admin/UpdatePagePatient${key}`}>
  //               <button className="btn btn-edit">Update</button>
  //             </Link>
  //             <button
  //               className="btn btn-delete"
  //               onClick={() => onDeleteRecord("patients", key)}
  //             >
  //               Delete
  //             </button>
  //           </div>
  //         </td>
  //       </tr>
  //     );
  //   });
  // };

  const renderTechnicianRows = (technicians) => {
    return Object.keys(technicians).map((key) => (
      <tr key={key}>
        <td>{technicians[key].Name}</td> {/* Name column */}
        <td>{technicians[key].Email}</td> {/* Email column */}
        <td>
          <div className="action-buttons">
            <Link to={`/Admin/UpdatePageTech${key}`}>
              <button className="btn btn-edit">Update</button>
            </Link>
            <button
              className="btn btn-delete"
              onClick={() => onDeleteRecord("technicians", key)}
            >
              Delete
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div className="main-content">
        <div className="adminsidebar">{/* Sidebar content */}</div>

        <div className="top-nav">
          {/* <h1
            style={{
              fontSize: "24px",
              margin: 0,
              textDecoration: "underline",
              marginLeft: "40px",
            }}
          >
            WELCOME
          </h1> */}
          <div style={{ marginTop: "100px" }}>
            <Link to="/Admin" className="homeButton">
              <i
                id="backIcon"
                className="fas fa-long-arrow-alt-left fa-lg fa-2x"
              ></i>
            </Link>
          </div>
        </div>

        <div className="container div-viewAll">
          <div className="card-header">
            <strong>AdminName:</strong>
            <span className="admin-name">{adminName1}</span>
            <hr />

            <div
              className={`accordion-section doctors-section ${
                activeSection === "doctors" ? "expanded" : ""
              }`}
            >
              <h3
                onClick={() => toggleSection("doctors")}
                className="accordion-title"
              >
                DOCTORS
                <span
                  className={`arrow ${
                    activeSection === "doctors" ? "up" : "down"
                  }`}
                ></span>
              </h3>

              {activeSection === "doctors" && (
                <>
                  {users.doctors && Object.keys(users.doctors).length > 0 ? (
                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th className="th-head">ID</th>
                          <th className="th-head">Name</th>
                          <th className="th-head T-ACTIONVIEWALL">Action</th>
                        </tr>
                      </thead>
                      <tbody>{renderDoctorRows(users.doctors)}</tbody>
                    </table>
                  ) : (
                    <p>No doctors available.</p>
                  )}
                </>
              )}
            </div>

            {/* <div
              className={`accordion-section patients-section ${
                activeSection === "patients" ? "expanded" : ""
              }`}
            >
              <h3
                onClick={() => toggleSection("patients")}
                className="accordion-title"
              >
                PATIENTS
                <span
                  className={`arrow ${
                    activeSection === "patients" ? "up" : "down"
                  }`}
                ></span>
              </h3>

              {activeSection === "patients" && (
                <>
                  {users.patients && Object.keys(users.patients).length > 0 ? (
                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th className="th-head">ID</th>
                          <th className="th-head">Name</th>
                          <th className="th-head">Age</th>
                          <th className="th-head">Doctor Assigned</th>
                          <th className="th-head T-ACTIONVIEWALL">Action</th>
                        </tr>
                      </thead>
                      <tbody>{renderPatientRows(users.patients)}</tbody>
                    </table>
                  ) : (
                    <p>No patients available.</p>
                  )}
                </>
              )}
            </div> */}

            <div
              className={`accordion-section technicians-section ${
                activeSection === "technicians" ? "expanded" : ""
              }`}
            >
              <h3
                onClick={() => toggleSection("technicians")}
                className="accordion-title"
              >
                TECHNICIANS
                <span
                  className={`arrow ${
                    activeSection === "technicians" ? "up" : "down"
                  }`}
                ></span>
              </h3>

              {activeSection === "technicians" && (
                <>
                  {users.technicians &&
                  Object.keys(users.technicians).length > 0 ? (
                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th className="th-head">Name</th>
                          <th className="th-head">Email</th>
                          <th className="th-head T-ACTIONVIEWALL">Action</th>
                        </tr>
                      </thead>
                      <tbody>{renderTechnicianRows(users.technicians)}</tbody>
                    </table>
                  ) : (
                    <p>No technicians available.</p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <ChatNot />
      </div>
      <ToastContainer />
    </>
  );
}

export default ViewAll;
